/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { advSearchState } from 'Stores/advSearch';
import { observer } from 'mobx-react';
import { userDetail } from 'Stores/userDetail';
import { advSearchFilterPopupState } from 'Stores/advSearchFIlterPopup';
import companySearchState from 'Stores/companySearch';
import * as CONSTANTS from 'Utils/constants';
import CheckBox from 'Components/common/CheckBox';

import { Utils } from 'Utils/utils';
import noSuggestionFound from 'Assets/png/noSuggestionFound.png';
import { ReactComponent as PlusIcon } from 'Assets/svg/plus-icon.svg';
import { ReactComponent as DropDownIcon } from 'Assets/svg/down-arrow-icon.svg';
import { ReactComponent as LockIcon } from 'Assets/svg/lock.svg';
import Dropdown from 'Components/common/dropdown';
import Button from 'Components/common/Button';

let renderListFun;
const DropDownBox = observer(props => {
  const {
    placeholder,
    suggestionList,
    noMatchFound,
    setNoMatchFound,
    setSelectedItem,
    suggestionKey,
    originalDropDownValue,
    setSuggestionList,
    searchBoxId,
    renderList,
    filterInPage = false,
    currentTab = 'contact',
    showDropdownIcon = true,
  } = props;

  let currentSelectedState;
  if (currentTab === 'contact')
    if (filterInPage) {
      currentSelectedState = advSearchState;
    } else {
      currentSelectedState = advSearchFilterPopupState;
    }
  else currentSelectedState = companySearchState;

  const selectedObj =
    currentSelectedState.appliedFilterSectionData[suggestionKey] || [];
  // console.log('suggestionKey dropdown', suggestionKey);
  // console.log('filterInPage ', filterInPage);

  const onInputFocus = e => {
    if (document !== undefined && filterInPage) {
      document
        .getElementsByClassName('left-section')[0]
        .classList.add('stop-scroll');

      // console.log('doc ', document.getElementById(searchBoxId));
      setTimeout(() => {
        if (
          document.getElementById(searchBoxId) !== undefined &&
          document.getElementById(searchBoxId) !== null
        )
          document.getElementById(searchBoxId).focus();
      }, 50);
    }
    const newArr = suggestionList.map(i => {
      const item = i;
      if (selectedObj.includes(item.pName)) item.selected = true;
      else item.selected = false;

      return item;
    });
    setSuggestionList(newArr);
  };

  const addSelectedItem = e => {
    const selectedVal = e.currentTarget.getAttribute('data-name');
    // debugger;
    let isApplyingFilter = false;
    const newArr = suggestionList.map(i => {
      const item = i;
      if (item.name === selectedVal)
        if (item.selected) {
          item.selected = false;
        } else {
          item.selected = true;
          isApplyingFilter = true;
        }

      return item;
    });
    // eslint-disable-next-line consistent-return
    const selectedArrNames = newArr.filter(item => {
      if (item.selected) return item.name;
    });
    const selectedItemVal = selectedArrNames.map(item => {
      return item.name;
    });
    setSuggestionList(newArr);
    if (setSelectedItem) setSelectedItem(selectedItemVal);

    if (isApplyingFilter) {
      const mxDataMap = {};
      if (currentTab === 'contact')
        if (filterInPage) mxDataMap.filterPlace = 'page';
        else mxDataMap.filterPlace = 'popup';
      else mxDataMap.filterPlace = 'page';

      const { isFreeTrial } = userDetail;

      mxDataMap.currentTab = currentTab;
      mxDataMap.filterKey = suggestionKey;
      mxDataMap.isFreeTrial = isFreeTrial;
      mxDataMap.searchValue = selectedVal;

      switch (suggestionKey) {
        case 'dept':
          mxDataMap.deptSearch = selectedVal;
          Utils.mixpanelTrack(
            CONSTANTS.MX_AS_EVENTS.AS_DEPARTMENT_SEARCH_PERFORMED,
            mxDataMap,
          );
          break;
        case 'employeeCount':
          mxDataMap.empCountSearch = selectedVal;
          Utils.mixpanelTrack(
            CONSTANTS.MX_AS_EVENTS.AS_EMPLOYEE_COUNT_SEARCH_PERFORMED,
            mxDataMap,
          );
          break;
        case 'regions':
          mxDataMap.regionSearch = selectedVal;
          Utils.mixpanelTrack(
            CONSTANTS.MX_AS_EVENTS.AS_REGIONS_SEARCH_PERFORMED,
            mxDataMap,
          );
          break;
        case 'level':
          mxDataMap.levelSearch = selectedVal;
          Utils.mixpanelTrack(
            CONSTANTS.MX_AS_EVENTS.AS_LEVEL_SEARCH_PERFORMED,
            mxDataMap,
          );
          break;
        case 'selectedCompanyList':
          mxDataMap.listSearch = selectedVal;
          Utils.mixpanelTrack(
            CONSTANTS.MX_AS_EVENTS.AS_LIST_SEARCH_PERFORMED,
            mxDataMap,
          );
          break;
        case 'revenue':
          mxDataMap.revenueSearch = selectedVal;
          Utils.mixpanelTrack(
            CONSTANTS.MX_AS_EVENTS.AS_REVENUE_SEARCH_PERFORMED,
            mxDataMap,
          );
          break;

        default:
          Utils.mixpanelTrack('AS Common Search Performed', mxDataMap);
          break;
      }
    }

    document.getElementById(searchBoxId).focus();
  };

  const filterDropDownRes = e => {
    setNoMatchFound(false);
    const inpVal = e.currentTarget.value.toLowerCase();
    const suggestionListArr = originalDropDownValue;
    // debugger;
    if (inpVal === '') {
      setSuggestionList(suggestionListArr);
    } else {
      const filterArrStartMatch = [];
      const filterArrIncludes = [];
      suggestionListArr.forEach(item => {
        if (
          item.name.toLowerCase().startsWith(inpVal) ||
          item.description?.toLowerCase().startsWith(inpVal)
        )
          filterArrStartMatch.push(item);
        else if (
          item.name.toLowerCase().includes(inpVal) ||
          item.description?.toLowerCase().includes(inpVal)
        )
          filterArrIncludes.push(item);
      });
      const filterArr = [...filterArrStartMatch, ...filterArrIncludes];
      if (filterArr.length === 0) setNoMatchFound(true);

      setSuggestionList(filterArr);
    }
  };
  renderListFun =
    renderList !== undefined
      ? () => renderList({ suggestionKey, suggestionList, addSelectedItem })
      : () => {
          return suggestionList.map((item, index) => {
            return (
              <div
                key={suggestionKey + index}
                className={`suggestion-item${item.selected ? ' selected' : ''}`}
                data-name={item.name}
                onClick={addSelectedItem}
              >
                <div className="check-box">
                  <CheckBox dymamicClass={item.selected ? 'selected' : ''} />
                </div>

                {item.name}
              </div>
            );
          });
        };

  const NoMatchFoundComponent = () => {
    return (
      <div className="no-match-found">
        <img src={noSuggestionFound} alt="No suggestion found" />
        No results found
      </div>
    );
  };

  return (
    <div className="dropdown-section">
      <Dropdown
        className="suggestion-list"
        toggleElement={
          <div className="dropdown-box" onClick={onInputFocus}>
            {placeholder}
            {selectedObj.length > 0 ? (
              <div className="dropdown-icon selected-count">
                <span>{selectedObj.length}</span>
              </div>
            ) : (
              showDropdownIcon && (
                // <i className="fa fa-plus dropdown-icon" aria-hidden="true" />
                <DropDownIcon
                  className="dropdown-icon plus-icon"
                  width={14}
                  height={14}
                />
              )
            )}
          </div>
        }
        onCloseDropdown={() => {
          setNoMatchFound(false);
          setSuggestionList(originalDropDownValue);
        }}
      >
        {(suggestionList.length > 0 || noMatchFound) && (
          <>
            <div
              className="pop-input-box-wrap"
              onClick={e => e.stopPropagation()}
            >
              <div className="pop-input-box">
                {/* <i className="fa fa-search" aria-hidden="true" /> */}
                <input
                  type="text"
                  id={searchBoxId}
                  className="pop-search-box"
                  onChange={filterDropDownRes}
                  placeholder={`Filter ${placeholder}`}
                />
              </div>
            </div>
            {noMatchFound ? (
              <div className="suggestion-list-wrap">
                <NoMatchFoundComponent />
              </div>
            ) : (
              <div
                className="suggestion-list-wrap"
                onClick={e => e.stopPropagation()}
              >
                {renderListFun()}
              </div>
            )}
          </>
        )}
        <Button
          btnText="Apply"
          className="apply-btn"
          disabled={suggestionList.every(data => !data.selected)}
          click={() => {
            const selectedArrNames = suggestionList.filter(item => {
              if (item.selected) return item.name;
            });
            currentSelectedState.setAppliedFilters(
              suggestionKey,
              selectedArrNames,
              null,
              true,
            );
          }}
        />
      </Dropdown>
    </div>
  );
});

export { DropDownBox };
export default DropDownBox;
